var map = {
	"./Gallery/1.jpg": 9697,
	"./Gallery/10.jpg": 1005,
	"./Gallery/2.jpg": 1926,
	"./Gallery/3.jpg": 451,
	"./Gallery/4.jpg": 8800,
	"./Gallery/5.jpg": 3373,
	"./Gallery/6.jpg": 466,
	"./Gallery/7.jpg": 3135,
	"./Gallery/8.jpg": 9036,
	"./Gallery/9.jpg": 3385,
	"./Icons/close.ico": 6099,
	"./Icons/edu.png": 7356,
	"./Icons/logo.png": 5295,
	"./Icons/menu.ico": 1778,
	"./Icons/work.png": 1649,
	"./ProjectImages/1_0.png": 7099,
	"./ProjectImages/1_1.png": 5970,
	"./ProjectImages/1_2.png": 4153,
	"./ProjectImages/1_3.png": 7248,
	"./ProjectImages/2_0.png": 6860,
	"./ProjectImages/2_1.png": 3397,
	"./ProjectImages/2_2.png": 7646,
	"./ProjectImages/2_3.png": 5335,
	"./ProjectImages/3_0.png": 8701,
	"./ProjectImages/3_1.png": 8756,
	"./ProjectImages/3_2.png": 3407,
	"./ProjectImages/3_3.png": 7078,
	"./ProjectImages/4_0.png": 558,
	"./ProjectImages/4_1.png": 9927,
	"./ProjectImages/4_2.png": 9292,
	"./ProjectImages/4_3.png": 8709,
	"./ProjectImages/5_0.png": 6623,
	"./ProjectImages/5_1.png": 5078,
	"./ProjectImages/5_2.png": 2637,
	"./ProjectImages/5_3.png": 1508,
	"./ProjectImages/6_0.png": 5872,
	"./ProjectImages/6_1.png": 73,
	"./ProjectImages/6_2.png": 1890,
	"./ProjectImages/6_3.png": 3435,
	"./ProjectImages/7_0.png": 6817,
	"./ProjectImages/7_1.png": 4104,
	"./ProjectImages/7_2.png": 8595,
	"./ProjectImages/7_3.png": 7834,
	"./ProjectImages/8_0.png": 4082,
	"./ProjectImages/8_1.png": 5211,
	"./ProjectImages/8_2.jpg": 468,
	"./ProjectImages/8_3.jpg": 8625,
	"./ProjectImages/9_0.png": 6147,
	"./ProjectImages/9_1.png": 9962,
	"./ProjectImages/9_2.png": 6209,
	"./ProjectImages/9_3.png": 7816,
	"./ProjectImages/9_4.png": 7431,
	"./ProjectImages/9_5.png": 1646,
	"./ProjectImages/9_6.png": 8373,
	"./ProjectImages/9_7.png": 6748,
	"./ProjectImages/9_8.png": 763,
	"./corporate.png": 1830,
	"./profilePic.jpg": 6726,
	"./profilePicSmall_old.jpg": 3035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1187;